/* eslint-disable @typescript-eslint/no-explicit-any */

import { nanoid } from 'nanoid';

// Define allowed billing periods - now including one_time
export type BillingPeriod = 'one_time' | 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'yearly';

// Define allowed product statuses (no "draft"!)
export type ProductStatus = 'active' | 'archived';
export type StatusType = ProductStatus;

export interface Product {
  id: string;
  title: string;
  name?: string;
  description?: string;
  amount: number;
  price_cents?: number;
  status?: ProductStatus;
  created_at: string;
  billing_period: BillingPeriod;
  one_time_fee?: number;
  use_anchor_billing?: boolean;
  anchor_billing_day?: number;
  hero_image?: string;
  user_id: string;
  is_test?: boolean;
  connectedAccountId?: string;
  isSubscription?: boolean;
  is_subscription?: boolean;
  type?: string;
  currency?: string;
  stripe_product_id?: string;
  stripe_price_id?: string;
}

const products: Product[] = [];
export const globalProducts: Product[] = products;

// Map DB -> Product, now uses billing_period
export const mapDatabaseToProduct = (dbProduct: any): Product => ({
  id: dbProduct.id,
  title: dbProduct.name || dbProduct.title,
  name: dbProduct.name,
  description: dbProduct.description || '',
  amount: dbProduct.price_cents || 0,
  price_cents: dbProduct.price_cents,
  status: dbProduct.status as ProductStatus || 'active',
  created_at: dbProduct.created_at,
  billing_period: dbProduct.billing_period || 'one_time',
  user_id: dbProduct.user_id,
  is_test: dbProduct.is_test || false,
  use_anchor_billing: dbProduct.use_anchor_billing,
  anchor_billing_day: dbProduct.anchor_billing_day,
  connectedAccountId: dbProduct.connectedAccountId,
  isSubscription: dbProduct.is_subscription,
  type: dbProduct.type,
  currency: dbProduct.currency || 'usd'
});

export const mapProductToDatabase = (product: Product): any => ({
  id: product.id,
  name: product.name || product.title,
  description: product.description || '',
  price_cents: product.price_cents || product.amount,
  billing_period: product.billing_period,
  status: product.status || 'active',
  user_id: product.user_id,
  is_test: product.is_test || false,
  use_anchor_billing: product.use_anchor_billing,
  anchor_billing_day: product.anchor_billing_day,
  connectedAccountId: product.connectedAccountId,
  is_subscription: product.is_subscription,
  type: product.type,
  stripe_product_id: product.stripe_product_id,
  stripe_price_id: product.stripe_price_id,
  currency: product.currency || 'usd'
});

export const createUniqueProductId = (): string => {
  return `prod_${nanoid(8)}`;
};
